import './App.css';
import Header from "./components/Header.js"
import Main from "./components/Main.js"


function App() {
  return (
    <div>
      <Header />
      <Main />
    </div>
  );
}

export default App;
